import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import DirectLogin from '../views/pages/DirectLogin.vue'
import Register from '../views/Registration/Register.vue'
import Address from '../views/Registration/Address.vue'
import Contract from '../views/Registration/Contract.vue'
import JobTypes from '../views/Registration/JobTypes.vue'
import Shifts from '../views/Registration/Shifts.vue'
import Transportation from '../views/Registration/Transportation.vue'
import NotFound from '../views/NotFound.vue'
import Dashboard from '../views/Dashboard.vue'
import Language from '../views/Language.vue'
import Assessment from '../views/pages/Assessment.vue'
import PasswordReset from '../views/PasswordReset.vue'
import NewPassword from '../views/NewPassword.vue'

import middleware from './middleware';

const routes = [
	{
		path: '/',
		// name: 'he',
		// component: Home,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang',
		name: 'home',
		component: Home,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/login',
		name: 'login',
		component: Login,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/direct-login/:key',
		name: 'directLogin',
		component: DirectLogin,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/register',
		name: 'register',
		component: Register,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/register/:companyslug',
		name: 'registerWithSlug',
		component: Register,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/register/address',
		name: 'registerAddress',
		component: Address,
		beforeEnter: middleware.user,
		props: true
	},
	{
		path: '/:lang/register/contract',
		name: 'registerContract',
		component: Contract,
		beforeEnter: middleware.user,
		props: true
	},
	{
		path: '/:lang/register/shifts',
		name: 'registerShifts',
		component: Shifts,
		beforeEnter: middleware.user,
		props: true
	},
	{
		path: '/:lang/register/jobtypes',
		name: 'registerJobtypes',
		component: JobTypes,
		beforeEnter: middleware.user,
		props: true
	},
	{
		path: '/:lang/register/transportation',
		name: 'registerTransportation',
		component: Transportation,
		beforeEnter: middleware.user,
		props: true
	},
	{
		path: '/:lang/dashboard',
		name: 'dashboard',
		component: Dashboard,
		beforeEnter: middleware.user
	},
	{
		path: '/:lang/forgot-password',
		name: 'forgotPassword',
		component: PasswordReset,
		beforeEnter: middleware.guest
	},
	{
		path: '/:lang/reset-password/:token/:email',
		name: 'newPassword',
		component: NewPassword,
		beforeEnter: middleware.guest
	},
	{
		path: '/language',
		name: 'language',
		component: Language,
		beforeEnter: middleware.guest
	},//]},
	{
		path: '/:lang/assessment',
		name: 'assessment',
		component: Assessment,
		beforeEnter: middleware.user
	},
	{
		path: '/404',
		component: NotFound,
		beforeEnter: middleware.guest
	},

]

var locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
let locales = {} 
locales['en-en'] = 'enEn';
locales['de-de'] = 'deDe';
locales['be-fr'] = 'beFr';
locales['be-nl'] = 'beNl';
locales['pl-pl'] = 'plPl';
locales['es-es'] = 'esEs';
locales['it-it'] = 'itIt';
locales['br-pt'] = 'brPt';
locales['tr-tr'] = 'trTr';
locales['hu-hu'] = 'huHu';
locales['nl-nl'] = 'nlNl';

if (!locales[locale]) {
	locale = 'language'	
} else {
	localStorage.setItem('locale', locale)
}
// if (locales[locale]) {
// 	localStorage.setItem('locale', locale)
// }

if (!localStorage.getItem('locale')) {
	localStorage.setItem('locale', locale)
	// this.$store.commit('SET_LANG', locale)
}

const router = createRouter({
	base: locale + '/',
	history: createWebHistory(),
	routes 
})

router.beforeEach(async (to, from, next) => {
	const hasLang = to.params && to.params.lang;
	const hadLang = from.params && from.params.lang; 
	if (hasLang && hadLang) {
		return next();
	} 

	if (to.path == '/language') {
		next();
		return;
	}

	if (!hasLang) { 
		return next(`/language`);
	}
	
	if (hasLang && !locales[hasLang]) {
		return next(`/${locale}${to.fullPath}`);
	} else { 
		return next();
	}
})

export default router
